jQuery(function ($) {
  const footer = $('[data-footer]');
  const submenus = footer.find('[data-submenu]');
  const submenuToggles = footer.find('[data-submenu-toggle]');

  submenuToggles.on('click', function () {
    const toggle = $(this);

    toggle.toggleClass('is-open');
    submenus.filter('[data-submenu="' + toggle.data('submenuToggle') + '"]').toggleClass('is-open');
  })
});
